import React, { ReactElement, useState } from 'react';
import { ImageWithInfo } from '@kursk/components/ui/ImageWithInfo/ImageWithInfo';
import { getAddress } from '@kursk/utils/getAddress';
import { IWidget } from '@common/redux/types/event';

import styles from './WidgetGeo.module.scss';
import { ShowMoreIcon } from "@kursk/components/ui/icons";
import classNames from "classnames";
import { YMap } from "@kursk/components/ui/YMap/YMap";

interface IProp {
  data: IWidget
}
const mediaSrc = [
  {
    media: '(min-width: 768px)',
    width: 640,
    height: 424,
  },
  {
    media: '(max-width: 767px)',
    width: 670,
    height: 448,
  }
]
export const WidgetGeo = ({ data }: IProp): ReactElement => {

  const [isShown, setIsShown] = useState(false);
  const { description, name, image, location, url } = data;

  const showMore = () => setIsShown(!isShown);

  return (
    <section className={styles.geo}>
      <div className={styles.wrapper}>
        <h3 className={styles.name}>
          {url ? <a href={url} target="_blank" rel="noreferrer">{name}</a> : name}
        </h3>
        {description &&
        <p className={styles.description}>
          {description}
        </p>
        }
        {location?.mapPosition?.coordinates?.length > 0 &&
        <p className={styles.coordinates}>
          {/* eslint-disable-next-line max-len */}
          {`GPS-координаты: ${location.mapPosition.coordinates[0].toFixed(6)}, ${location.mapPosition.coordinates[1].toFixed(6)}`}
        </p>
        }
        {location?.address &&
        <div className={styles.addressWrapper}>
          <button
            className={styles.button}
            onClick={() => showMore()}>
            <div className={styles.address}>
              {getAddress(location.address)}
              <ShowMoreIcon
                classes={classNames([styles.showMoreIcon, isShown && styles.rotate])}
                width={12}
                height={5}
              />
            </div>
          </button>
        </div>
        }
      </div>
      {image &&
      <div className={styles.imageWrapper}>
        <div className={styles.image}>
          <ImageWithInfo className={styles.imageWithInfo} image={image} srcSet={mediaSrc} />
        </div>
      </div>
      }
      {isShown &&
      <div className={styles.mapWrapper}>
        <YMap
          mapPosition={location.mapPosition}
          placeName={name}
        />
      </div>
      }
    </section>
  );
};
